import React from 'react';
import styled from 'styled-components';
import Image, { type GfxImage } from 'components/GfxImage';
import type { Maybe } from '.tina/__generated__/types';

const Container = styled(Image)`
  display: inline-flex;
  width: 100%;
  padding: ${({ $horizontalPaddingMobile }) => $horizontalPaddingMobile && '0 1.5rem'};
  ${({ theme }) => theme.mq.md`
    padding: 0;
  `}
`;

type TinaImage = Omit<GfxImage, 'src'> & {
  src: Maybe<string> | undefined;
  layout?: 'fill' | 'fixed' | 'intrinsic' | 'responsive' | undefined;
};

const TinaImage: React.FC<TinaImage> = ({
  src,
  layout = undefined,
  width = 1024,
  height = 768,
  ...props
}) => {
  if (!src) {
    return null;
  }
  return <Container layout={layout} width={width} height={height} {...props} src={src} />;
};

export default TinaImage;
